module.exports = __webpack_public_path__ + "static/media/test9_3.fdff9bcd.png";